import { cn } from '@/utils/cn';

type BadgeVariant = 'default' | 'success' | 'warning' | 'error' | 'info' | 'purple';

interface BadgeProps {
  label:     string;
  variant?:  BadgeVariant;
  dot?:      boolean;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  default: 'bg-surface-100 text-surface-600',
  success: 'bg-emerald-100 text-emerald-700',
  warning: 'bg-amber-100   text-amber-700',
  error:   'bg-red-100     text-red-700',
  info:    'bg-blue-100    text-blue-700',
  purple:  'bg-purple-100  text-purple-700',
};

const dotClasses: Record<BadgeVariant, string> = {
  default: 'bg-surface-400',
  success: 'bg-emerald-500',
  warning: 'bg-amber-500',
  error:   'bg-red-500',
  info:    'bg-blue-500',
  purple:  'bg-purple-500',
};

export default function Badge({ label, variant = 'default', dot = false, className }: BadgeProps) {
  return (
    <span className={cn(
      'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium',
      variantClasses[variant],
      className
    )}>
      {dot && <span className={cn('h-1.5 w-1.5 rounded-full', dotClasses[variant])} />}
      {label}
    </span>
  );
}
